import { ISelectOptions } from "../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { Host } from "../../../yoello-lib/modules/host/Hosts";


export enum NewVenueStages {
    VenueDetails = "VenueDetails",
    VenueSubscription = "VenueSubscription",
    Completed = "Completed"
}

export interface INewVenueState {
    VenueDetails?: Partial<INewVenueData>,
    stage: NewVenueStages;
    selectedSubscription?: string;
    host: Host;
    leadId?: string;
    hubspotId?: string;
}

interface INewVenueData {
    venue_name: string;
    venue_location: ISelectOptions;
}

export enum HubSpotSetUpStages {
    SIGNED_IN = "Signed in",
    MERCHANT_DETAILS = "Merchant details complete",
    PAYMENT_REGISTRATION = "Payment registration complete",
    PAYMENT_AUTHORISATION = "Payment authorisation_complete",
    BUSINESS_TRADED = "Business has traded"
}
